import { createSlice } from "@reduxjs/toolkit";
import { getAuthData } from "helpers/api/authService";
import { getSettings, setSettings, NavigationSettings } from "helpers/settings";

//If we"re not logged in, then the userId will be null and therefore 0 will be used, this will result in no settings being found and therefore using the defaults
//If a user is logged in though, then it will automatically read the token data properly and know the userId and therefore use their settings
let userName = getAuthData()?.userName ?? "0";
let initialSettings = getSettings("navSlice", userName) as NavigationSettings ?? {
    configType: "navSlice",
    userId: userName,
    darkMode: true,
    debugMode: false,
    isSideMenuOpen: false,
    isSideMenuMobileOpen: false,
    storeGroupId: null
};

//Navigation hook slice something something... I don"t understand these terms

const navSlice = createSlice({
    name: "navSlice",
    initialState: {
        isSideMenuOpen: initialSettings.isSideMenuOpen,
        isSideMenuMobileOpen: initialSettings.isSideMenuMobileOpen,
        darkMode: initialSettings.darkMode,
        debugMode: initialSettings.debugMode,
        storeGroupId: initialSettings.storeGroupId
    },
    reducers: {
        toggleSideMenu: state => {
            state.isSideMenuOpen = !state.isSideMenuOpen;
            initialSettings.isSideMenuOpen = state.isSideMenuOpen;
            setSettings(initialSettings);
        },
        toggleSideMenuMobile: state => {
            state.isSideMenuMobileOpen = !state.isSideMenuMobileOpen;
            initialSettings.isSideMenuMobileOpen = state.isSideMenuMobileOpen;
            setSettings(initialSettings);
        },
        changeTheme: state => {
            state.darkMode = !state.darkMode;
            initialSettings.darkMode = state.darkMode;
            setSettings(initialSettings);
        },
        setDebug: state => {
            state.debugMode = !state.debugMode;
            initialSettings.debugMode = state.debugMode;
            setSettings(initialSettings);
        },
        setStoreGroup: (state, action) => {
            state.storeGroupId = action.payload;
            initialSettings.storeGroupId = state.storeGroupId;
            setSettings(initialSettings);
        }
	}
})

export const { toggleSideMenu, toggleSideMenuMobile, changeTheme, setDebug, setStoreGroup } = navSlice.actions

export default navSlice.reducer;
